import type { CSSProperties } from 'react';

import { useMediaQuery } from '../../../../lib/useMediaQuery';

/** A finger-driven screen, where small buttons are hard to hit. */
const TOUCH_POINTER = '(pointer: coarse)';
/** The smallest comfortable tap target, in px. */
const TOUCH_TARGET = 44;

/** Compact on desktop; at least a full tap target on touch screens. */
export function useRowActionStyle(): CSSProperties {
  const touch = useMediaQuery(TOUCH_POINTER);
  return touch
    ? { height: TOUCH_TARGET, minWidth: TOUCH_TARGET, padding: '0 12px', fontSize: 12 }
    : { height: 24, padding: '0 8px', fontSize: 11 };
}
